<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">How to use PPK Downloader</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">What this tool does</div>
      <div class="text-muted">
        <div class="mb-2">
          PPK Downloader makes PPK (Post-Processed Kinematic) workflows simple and convenient. It can download RTCM data files directly from your NTRIP mountpoint,
          so you can generate highly accurate PPK solutions with ease.
        </div>
        <div class="mb-2">
          No need to set up and maintain a base station for PPK propose — just capture your Rover data and retrieve the base data from your existing mountpoints.
        </div>
        <div class="mb-2">
          Achieving centimeter-level accuracy has never been easier: simply bring a standalone RTK GNSS logger (for example: Columbus EX-1 RTK GNSS data logger) with you —
          no internet connection required.
        </div>
        <div>
          PPK Downloader supports up to 24 hours of continuous data recording, securely stored in the cloud for 7 days.
          You can start recording right away or schedule downloads to fit your project timeline.
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Before you start</div>
      <div class="text-muted">
        If you haven’t configured a mount point connection yet, click <strong>MountPoint Setup</strong> and add one.
        The settings will be saved for future recordings.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Workflow</div>
      <ol class="mb-2">
        <li>Click <strong>MountPoint Setup</strong> to add/edit your NTRIP mount point connection.</li>
        <li>Select a mount point from <strong>Select a Mount Point</strong>.</li>
        <li>Set <strong>Recording Start Time</strong> (must be at or after your current system time).</li>
        <li>Choose a <strong>Recording Duration</strong>.</li>
        <li>Click <strong>Submit the Task</strong>. Then click <strong>Refresh</strong> to check status and get the download link.</li>
      </ol>
      <div class="text-muted">
        You can leave this page after submitting. The task runs in the backend.
      </div>
    </div>

    <div class="mb-1">
      <div class="section-title">Tip</div>
      <ul class="text-muted mb-0">
        <li>If a download link expires, submit a new task to generate a new file.</li>
        <li>Files are kept for a limited time (7 days).</li>
        <li>Please make sure the mountpoint you download from is up and running.</li>
      </ul>
    </div>
  </div>
</div>


